<template>
  <Row
    class="bottom"
    type="flex"
    :style="{
      background: userinfo.prefer_obj
        ? userinfo.prefer_obj.color || 'rgb(9,136,91)'
        : 'rgb(9,136,91)'
    }"
  >
    <i-col :xs="24" :md="6" v-for="(i, ix) in bottomnav" :key="ix">
      <ul>
        <a
          @click="
            $emit('childEvent', {
              cmd: i.event || 'routergoto',
              data: i.to,
            })
          "
          >{{ i.name }}</a
        >
        <ol v-for="(j, jx) in i.sub" :key="jx" :class="j.QR_code ? ['QR_code', j.QR_code] : ''">
            <a
              @click="
                $emit('childEvent', {
                  cmd: j.event || 'routergoto',
                  data: j.to,
                })
              "
              >{{ j.name }}</a
            >
            <div v-if="j.QR_code" class="QR_code_container">
              <img
                :src="`https://biocore.sjtu.edu.cn/static/assets/img/web/${j.QR_code}.jpg`"
                alt="二维码"
              />
            </div>
        </ol>
      </ul>
    </i-col>
    <i-col span="24" style="color: #ddd; font-size: 12px; padding-top: 15px;text-align:center;">
      上海网正信息科技有限公司 v{{ $store.state.version }} Company 2021 版权所有
      © 沪 ICP 备 20020192 号
    </i-col>
  </Row>
</template>


<script>
export default {
  name: "bottom",
  data() {
    return {
      bottomnav: [
        {
          name: "仪器开放平台",
          to: "/",
          sub: [{ name: "登录", event: "showlogin", to: "/" }],
        },
        {
          name: "学院信息",
          to: "/",
          sub: [
            { name: "研究院简介", to: "/introduction" },
            { name: "联系我们", to: "/contact" },
          ],
        },
        {
          name: "友情链接",
          to: "/",
          sub: [
            {
              name: "上海交通大学",
              event: "href",
              to: "http://www.sjtu.edu.cn",
            },
            {
              name: "上海交通大学生命学院",
              event: "href",
              to: "https://life.sjtu.edu.cn/",
            },
            {
              name: "仪器共享服务平台",
              event: "href",
              to: "https://pharm.sjtu.edu.cn",
            },
          ],
        },
        {
          name: "移动端",
          sub: [
            {
              name: "微信公众号",
              QR_code: "qrcode_for_gh_15ad78e2e6f6_430",
            },
            { name: "微信小程序", QR_code: "gh_52bd07e00824_430" },
          ],
        },
      ],
    };
  },
  computed: {
    userinfo() {
      return this.$store.state.user;
    },
  },
};
</script>

<style scoped>
.bottom {
  display: flex;
  color: #fff;
  justify-content: space-around;
  align-items: flex-start;
  padding: 1em;
  width: 100%;
  position: fixed;
  font: 18px/1.5 Tahoma, Helvetica, Arial, Microsoft YaHei, sans-serif;
  transition: all 1s ease;
  max-height: 300px;
bottom: -130px;
}
ul a {
  color: #dfd9cb;
  font-size: 18px;
}
ol a {
  color: #ccc;
  font-size: 14px;
}

.QR_code {
  position: relative;
}

.QR_code_container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 10%;
  bottom: 100%;
  width: 70%;
  height: 0;
  border-radius: 5%;
  background-color: #fff;
  opacity: 0;
  overflow: hidden;
  transition: 0.5s linear 0.1s;
}

.QR_code_container > img {
  width: 80%;
}

.bottom:hover {
  bottom: 0;
  /*padding: 3em;*/
  box-shadow: -2px -2px 20px rgba(40, 40, 40, 0.8);
  border-radius: 1em 1em 0 0;
  transition: all 1.2s ease;
}

.bottom:hover ul a {
  color: #f0ce76;
  transition: all 1.2s ease;
}
.bottom:hover ol {
  /*margin-top:0.3em;*/
  transition: all 1.2s ease;
}
.bottom:hover ol a {
  color: #fff;
  transition: all 1.2s ease;
}
.bottom ol a:hover + .QR_code_container {
  height: auto;
  opacity: 1;
}
</style>
